import { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import logo from '../assets/img/image.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/socialIcon4.png';
import navIcon3 from '../assets/img/nav-icon3.svg';


export const NavBar=()=>{

    const [activeLink,setActiveLink]=useState('home');
    const [scrolled,setScrolled]=useState(false);

    useEffect(()=>{
        const onScroll=()=>{
            if(window.scrollY>50){
                setScrolled(true);
            }
            else{
                setScrolled(false);
            }
        }
        window.addEventListener("scroll",onScroll);
        return ()=> window.removeEventListener("scroll",onScroll);
    })
    const onUpdateActiveLink = (value)=>{
        setActiveLink(value);
    }


    return (
    <Navbar className={scrolled?"scrolled":""} expand="lg">
    <Container>
    <Navbar.Brand href="#home">
        <img src={logo} alt="logo" className="logo"/>
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <span className="navbar-toggle-icon"></span>
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="me-auto">
        <Nav.Link href="#home" className={activeLink ==='home'?'active navbar-link': 'navbar-link' }  onClick={()=> onUpdateActiveLink('home')}>Home</Nav.Link>
        <Nav.Link href="#projects" className={activeLink ==='projects'?'active navbar-link': 'navbar-link' } onClick={()=> onUpdateActiveLink('projects')}> Projects</Nav.Link>
        <Nav.Link href="#skills" className={activeLink ==='skills'?'active navbar-link': 'navbar-link' } onClick={()=> onUpdateActiveLink('skills')}> Skills</Nav.Link>
      </Nav>
      <span className="navbar-text">
        <div className="social-icon">
            <a href="https://www.linkedin.com/in/a-sai-ram-reddy-7596a9254/"> <img src={navIcon1} alt="" /></a>
            <a href="https://www.youtube.com/@sairamrdya"> <img src={navIcon2} alt="" /></a>
            <a href="https://www.instagram.com/mr_sairam_arava"> <img src={navIcon3} alt="" /></a>
            <button className="vvd" onClick={()=>console.log('conect')}><span>Let's Connect</span></button>
        </div>
      </span>
    </Navbar.Collapse>
    </Container>
    </Navbar>
    )
}
